// extracted by mini-css-extract-plugin
export default {"containerCards":"Central_containerCards__KxQ4v"};